<script lang="ts" setup>
  import { DocumentType } from '@storefront/types';
  import type { PropType } from 'vue';
  import { StoreLayout, AccountLayout } from '@storefront/components';
  import type { OrderResource } from '@storefront/resources';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });


  type OrderDocument = {
    id: number;
    type: DocumentType;
    reference_number: string;
    download: string;
  }

  defineProps({
    order: { type: Object as PropType<OrderResource>, required: true },
    repayment: { type: String, required: false },
    complaint: { type: String, required: false },
    refund: { type: String, required: false },
    reorder: { type: String, required: false },
    documents: { type: Array as PropType<OrderDocument[]>, required: false, default: [] },
    packages: { type: Array, required: false, default: [] },
    shipments: { type: Array, required: false, default: [] },
  });
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.order.index')">
    {{ $t('SHOP.ACCOUNT.HEADER.ORDER_NUMBER', { number: order.number }) }}
  </AccountMobileNavigation>
  <OrderDetailsView v-bind="$props" />

  <RouterView />
</template>
